<template>
    <dialog-modal :show="comment" @close="close">

        <template #title>
            <div class="flex items-center">
                <span :class="{'opacity-0':!comment}">
                    Want to delete this comment?
                </span>
                <modal-close @close="close"/>
            </div>
        </template>

        <template #content>
            <div class="flex gap-6" :class="{'opacity-0':!comment}">
                <div class="flex-shrink-0 w-12 h-12 rounded-full overflow-hidden">
                    <img :src="commentPhoto" class="object-cover" alt="Comment User Photo">
                </div>
                <div class="text-base text-gray-600">
                    <article ref="commentHtml" :class="[isLineClamped ? 'line-clamp-4' : 'line-clamp-none']" v-html="commentText"></article>
                    <div v-if="isLineClamped">
                        <button @click.prevent="toggleReadMore"
                           class="bg-transparent text-base font-medium text-gray-600 text-center hover:text-gray-700">{{
                                isLineClamped ? 'Read More' : 'Read Less'
                            }}</button>
                    </div>
                </div>
            </div>
        </template>

        <template #footer>
                <jet-button color="red" :focus="!!comment" @click.native="submit">
                    Delete
                </jet-button>
        </template>

    </dialog-modal>
</template>

<script>

import DialogModal from '@/Jetstream/DialogModal';
import SecondaryButton from '@/Jetstream/SecondaryButton';
import DangerButton from '@/Jetstream/DangerButton';
import JetButton from '@/Jetstream/Button';
import ModalClose from '@/Components/ModalClose';

export default {

    name: 'DeleteCommentModal',
    components: { ModalClose, JetButton, DangerButton, SecondaryButton, DialogModal },

    mounted() {
        this.$nextTick(() => {
            if (this.$refs.commentHtml && this.$refs.commentHtml.length) {
                this.isLineClamped = this.$refs.commentHtml.scrollHeight > this.$refs.commentHtml.clientHeight;
            }
        });
    },

    props: {
        comment: {
            default: null,
            type: Object
        }
    },

    computed: {
        commentUsername(){
            if(!this.comment) return null;
            return this.comment.tag;
        },
        commentPhoto(){
            if(!this.comment) return null;
            return this.comment.profilePhotoUrl;
        },

        commentText(){
            if(!this.comment) return null;
            return this.comment.text;
        }
    },

    data() {
        return {
            form: this.$inertia.form({
                _method: 'POST',
            }),
            isLineClamped: true
        }
    },

    methods: {
        submit(){
            // this.form.post(this.route('posts.destroy', {post: this.post}), {
                // onFinish: () => this.$inertia.get(route('dashboard'))
            // })
        },

        close() {
            this.$emit('update:comment', null);
        },

        toggleLineClamp(){
            this.isLineClamped = !this.isLineClamped;
        }
    },

}

</script>
